.mediaInListPlaceholder {
  text-align: center;
  width: 100%;
  height: 100%;
}
.mediaInListPlaceholderContentWrapper {
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;

  a {
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  svg {
    width: 80%;
    height: 80%;
  }
}
